import { render, staticRenderFns } from "./noticeTab.vue?vue&type=template&id=c604595e&scoped=true"
import script from "./noticeTab.vue?vue&type=script&lang=js"
export * from "./noticeTab.vue?vue&type=script&lang=js"
import style0 from "./noticeTab.vue?vue&type=style&index=0&id=c604595e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c604595e",
  null
  
)

export default component.exports